<template>
    <div class="TTL-Genealogy">
        <div class="TTL-Genealogy-title">
            <el-form :inline="true">
                <el-form-item>
                <a class="TTL-fresh" @click="freshInit"></a>
                </el-form-item>
                <el-form-item>
                <div class="TTL-input">
                <el-input v-model="homememberparam.key" placeholder="家庭成员名称" round size="large" clearable @change="homememberparam.ischange=true"/>
                </div>
                </el-form-item>
                <el-form-item>
                <el-button type="warning" size="large" round @click="getHomeMemberlists">搜索</el-button>
                </el-form-item>
                <el-form-item>
                <el-button type="warning" size="large" round @click="addHomeMember">新增家庭成员</el-button>
                </el-form-item>
            </el-form>

            <div class="TTL-table">
            <el-table :data="homememberlists" stripe="true" style="width: 100%" empty-text="" v-loading="homememberparam.loading">
                <template v-slot:empty><div class="TTL-table-no-data"><el-empty description="暂无数据" /></div></template>
                <el-table-column prop="name" label="管理员头像" width="120">
                    <template #default="scope">
                        <div class="TTL-setting-image-list">
                        <el-image 
                        :src="scope.row.avar" 
                        :preview-src-list="[scope.row.avar]" 
                        :initial-index="1"
                        preview-teleported="true"
                        :zoom-rate="1.2" 
                        fit="cover"  
                        />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名字" />
                <el-table-column prop="birthday" label="生日" />
                <el-table-column prop="age" label="年龄" />
                <el-table-column label="操作" align="center" fixed="right" min-width="150">
                    <template #default="scope">
                        <el-button type="warning" size="middle" round @click="edithomemember(scope.row.id)">编辑</el-button>
                        <el-button type="warning" size="middle" round @click="PrenatalCheckInfo(scope.row.id)">产检信息</el-button>
                        <el-button type="warning" size="middle" round @click="getbirthdays(scope.row.id)">出生信息</el-button>
                        <el-button type="warning" size="middle" round @click="checkcase(scope.row.id)">病例档案</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block TTL-page-block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="homememberparam.p"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="homememberparam.rollpage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="homememberparam.row"
                />
            </div>
            </div>

        </div>

        <!-- 自定义组件 -->
        <!-- 新增/编辑家庭成员 -->
        <MemberAddOrEdit :value="MemberAddOrEditparam.view" :memberid="MemberAddOrEditparam.memberid" @MemberAddOrEditfinish="MemberAddOrEditfinish" />
        <!-- 产检信息 -->
        <PrenatalInfo :value="PrenatalCheckparam.view" :memberid="PrenatalCheckparam.memberid" :type="PrenatalCheckparam.type" @PrenatalInfofinish="PrenatalInfofinish" />
        <!-- 生日信息 -->
        <BirthdayInfos :value="birthdayparam.view" :memberid="birthdayparam.memberid" @birthdayfinish="birthdayfinish"/>

    </div>
</template>

<script>
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
import MemberAddOrEdit from '@/views/Home/Module/MemberAddOrEdit.vue';
import PrenatalInfo from '@/views/Home/Module/PrenatalInfo.vue';
import BirthdayInfos from '@/views/Home/Module/BirthdayInfos.vue';
export default {
    components:{
        MemberAddOrEdit,PrenatalInfo,BirthdayInfos
    },
    data() {
        return {

            /** 搜索参数 **/
            homememberparam: {
                key:'',
                loading:false,
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },

            /** 成员列表信息 **/
            homememberlists:[],

            /** 新增/编辑成员信息 **/
            MemberAddOrEditparam: {
                view:false,
                memberid:'',
            },

            /** 查看产检信息 **/
            PrenatalCheckparam: {
                view:false,
                memberid:'',
                type:1,
            },

            birthdayparam: {
                view:false,
                memberid:'',
            },

        }
    },

    mounted() {
        this.getHomeMemberlists(); //获取家庭成员列表
    },

    methods: {

        /** 刷新数据 **/
        freshInit() {
            var load=this.$loading.service(this.$loadingparam); //加载loading动画
            this.getHomeMemberlists(); //刷新角色列表
            load.close(); //关闭loading动画
        },


        /** 获取家庭成员列表 **/
        getHomeMemberlists() {
            if(this.homememberparam.ischange) {
                this.homememberparam.ischange=false;
                this.homememberparam.p=1;
                this.homememberparam.rollpage=10;
            }

            this.homememberparam.loading=true;
            INTERFACE_MODEL_GENEALOGY.GET_HOME_MEMBER_LISTS(this.homememberparam).then((res) => {
                this.homememberparam.loading=false;
                if(res.status > 0) return false;
                this.homememberparam.row=res.data.count;
                this.homememberlists=res.data.list;
                console.log(res.data.list);
            });
        },


        /** 调整每页条数 **/
        handleSizeChange(e) {
            this.homememberparam.rollpage=e;
            this.getHomeMemberlists();
        },


        /** 调整页数 **/
        handleCurrentChange(e) {
            this.homememberparam.p=e;
            this.getHomeMemberlists();
        },


        /** 新增/编辑家庭成员信息 **/
        addHomeMember() {
            this.MemberAddOrEditparam.view=true;
            this.MemberAddOrEditparam.memberid=0;
        },


        /** 百年祭家庭成员信息 **/
        edithomemember(id) {
            this.MemberAddOrEditparam.view=true;
            this.MemberAddOrEditparam.memberid=id;
        },


        /** 新增/编辑成员回调函数 **/
        MemberAddOrEditfinish(e) {
            this.MemberAddOrEditparam.view=false;
            this.getHomeMemberlists(); //刷新列表
        },


        /** 产检信息 **/
        PrenatalCheckInfo(id) {
            this.PrenatalCheckparam.view=true;
            this.PrenatalCheckparam.memberid=id;
            this.PrenatalCheckparam.type=1;
        },


        /** 病例信息 **/
        checkcase(id) {
            this.PrenatalCheckparam.view=true;
            this.PrenatalCheckparam.memberid=id;
            this.PrenatalCheckparam.type=2;
        },


        /** 产检信息回调函数 **/
        PrenatalInfofinish() {
            this.PrenatalCheckparam.view=false;
            this.getHomeMemberlists(); //获取家庭成员列表
        },


        /** 获取出生信息 **/
        getbirthdays(memberid) {
            this.birthdayparam.view=true;
            this.birthdayparam.memberid=memberid;
        },

        /** 出生信息回调函数 **/
        birthdayfinish() {
            this.birthdayparam.view=false;
            this.getHomeMemberlists(); //获取家庭成员列表
        },


    }

}
</script>